import {
  FormControlDependsOnSchema,
  FormControlDependsOnThenEnum,
  getFullPropertyPath,
  getValuesPropertyMap
} from "@generation/core";

import { useDataContext } from "../Context/DataContextProvider";
import { getValueFromObject } from "../Utils/ValueUtils";

export interface IUseDependsOnHookResult {
  hide?: boolean;
  disabled?: boolean;
  isRequired?: boolean;
}

export const useDependsOnHook = (
  baseName: string,
  dependsOn?: FormControlDependsOnSchema[]
): IUseDependsOnHookResult => {
  if (!dependsOn) {
    return {};
  }

  let result: IUseDependsOnHookResult = {
    disabled: undefined,
    hide: undefined,
    isRequired: undefined,
  };

  dependsOn.forEach((item) => {
    let values: any = {};

    if (item.isAbsolutePropertyPath === true) {
      values = getValuesPropertyMap(
        useDataContext(),
        item.properties,
        getValueFromObject
      );
    } else {
      const baseFieldName = `${baseName}${baseName ? "." : ""}`;

      const fieldMappings: { input: string; fullPath: string }[] = [];

      const fields = item.properties.map((property: string) => {
        const fullPath = getFullPropertyPath(baseFieldName, property);

        fieldMappings.push({
          input: property,
          fullPath,
        });

        return fullPath;
      });

      values = getValuesPropertyMap(
        useDataContext(),
        fields,
        getValueFromObject,
        (fieldName: string) =>
          fieldMappings.find((fieldItem) => fieldItem.fullPath === fieldName)
            ?.input ?? fieldName
      );
    }
    const ifResult = item.if(values);

    result = {
      hide:
        !result.hide && item.then === FormControlDependsOnThenEnum.Hide
          ? ifResult
          : result.hide,
      disabled:
        !result.disabled && item.then === FormControlDependsOnThenEnum.Disable
          ? ifResult
          : result.disabled,
      isRequired:
        !result.isRequired &&
        item.then === FormControlDependsOnThenEnum.IsRequired
          ? ifResult
          : result.isRequired,
    };
  });

  return result;
};
